<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-menu
      v-if="isMobile"
      offset-x
      right
    >
      <template #activator="{ on, attrs }">
        <v-icon
          dark
          large
          color="#37474F"
          v-bind="attrs"
          v-on="on"
        >
          mdi-menu
        </v-icon>
      </template>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getProfileDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-account
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              My Profile
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getOrganizationDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-domain
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Organization
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="userOrganizationCategoryCheck('advertiser')"
            link
            @click="getPaymentsHistory()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-credit-card-check-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Payments
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="userOrganizationCategoryCheck('advertiser')"
            link
            @click="getOrganizationPurchaseHistory()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-clipboard-text-clock
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Purchases
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-navigation-drawer
      v-if="!isMobile"
      permanent
      color="#ECEFF1"
      expand-on-hover
      absolute
      bottom
      floating
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="nav-title-style">
              <v-list-item-icon>
                <v-icon
                  style="font-size:25px;color:#37474F;font-weight:bold;"
                >
                  mdi-account-cog
                </v-icon>
              </v-list-item-icon>
              Profile
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <br>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getProfileDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-account
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              My Profile
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getOrganizationDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-domain
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Organization
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="userOrganizationCategoryCheck('advertiser')"
            link
            @click="getPaymentsHistory()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-credit-card-check-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Payments
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="userOrganizationCategoryCheck('advertiser')"
            link
            @click="getOrganizationPurchaseHistory()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-clipboard-text-clock
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Purchases
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <div>
      <user-profile v-if="showProfileDetails" />
      <organization-details v-if="showOrganizationDetails" />
      <subscriptions-history v-if="showPaymentsHistory" />
      <organization-purchase-history v-if="showOrganizationPurchaseHistory" />
    </div>
  </v-container>
</template>

<script>
import global from 'src/mixins/global';
import UserProfile from './UserProfile.vue';
import Constants from 'src/constants';
import OrganizationDetails from './organization/OrganizationDetails.vue';
import SubscriptionsHistory from './payments/SubscriptionsHistory.vue';
import OrganizationPurchaseHistory from './organization/OrganizationPurchaseHistory.vue';

 export default {
    name: 'ProfileSettings',
    components: {
      'user-profile': UserProfile,
      'organization-details': OrganizationDetails,
      'subscriptions-history': SubscriptionsHistory,
      'organization-purchase-history': OrganizationPurchaseHistory,
    },
    mixins: [global],
    data: () => ({
      selectedItem: -1,
      showProfileDetails: true,
      showOrganizationDetails: false,
      showPaymentsHistory: false,
      showOrganizationPurchaseHistory: false,
    }),
    computed: {
      isMobile () {
        if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return false;
        } else {
          return true;
        }
      },
    },
    mounted () {
      this.selectedItem = 0;
    },
    methods: {
      getProfileDetails () {
        this.showOrganizationDetails = false;
        this.showPaymentsHistory = false;
        this.showOrganizationPurchaseHistory = false;
        this.showProfileDetails = true;
      },
      getOrganizationDetails () {
        if (this.permissionCheck('get-organization-details') === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'You are not authorized to perform this action. Please contact your administrator.',
            type: Constants.ALERT_TYPE_INFO,
          });
          return;
        }
        this.showPaymentsHistory = false;
        this.showProfileDetails = false;
        this.showOrganizationPurchaseHistory = false;
        this.showOrganizationDetails = true;
      },
      getPaymentsHistory () {
        if (this.permissionCheck('read-subscriptions') === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'You are not authorized to perform this action. Please contact your administrator.',
            type: Constants.ALERT_TYPE_INFO,
          });
          return;
        }
        this.showOrganizationDetails = false;
        this.showProfileDetails = false;
        this.showOrganizationPurchaseHistory = false;
        this.showPaymentsHistory = true;
      },
      getOrganizationPurchaseHistory () {
        this.showOrganizationDetails = false;
        this.showProfileDetails = false;
        this.showPaymentsHistory = false;
        this.showOrganizationPurchaseHistory = true;
      },
    },
  };

</script>
<style scoped>
.nav-title-style {
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #37474F;
  font-size: 25px;
}
</style>
